import injectSheet from 'react-jss'
import AutocompleteSimple from './AutocompleteSimple'
import styles from './AutocompleteSimple.styles'

export default injectSheet(styles)(AutocompleteSimple)
